/* eslint-disable jsx-a11y/iframe-has-title */
/**
 *
 * This component is responsible to load various scripts into the layout.
 *
 */
import { FC } from "react";

import Script from "next/script";

import { useRouter } from "@lib/router";
import getEnv from "@utils/getEnv";

import { TScriptOptions } from "./types";

const hotjarSrcMap = {
  lt: "/assets/scripts/hotjar-lt.js",
};

/**
 *
 * "next/script" allows us to define our scripts anywhere without the need to append them to <head>.
 * It also handles script loading strategy.
 *
 */
const Scripts: FC<TScriptOptions> = ({ hasTagManager }) => {
  const { defaultLocale } = useRouter();

  const shouldLoadHotjar = getEnv("NEXT_PUBLIC_USE_HOTJAR") !== "false";

  return (
    <>
      {shouldLoadHotjar && (
        <Script src={hotjarSrcMap[defaultLocale!]} strategy="afterInteractive" onError={console.error} />
      )}
    </>
  );
};
export default Scripts;
